import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Divider as Divider$1 } from '@mantine/core';
import { useDividerStyle } from './Divider.style.js';
import { objectDeepMerging } from '../../utils/index.js';

var _excluded = ["styles", "labelPosition", "color", "type"];
var Divider = function Divider(props) {
  var _props$styles = props.styles,
    styles = _props$styles === void 0 ? {} : _props$styles,
    _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? 'center' : _props$labelPosition,
    color = props.color,
    _props$type = props.type,
    type = _props$type === void 0 ? 'divider-1' : _props$type,
    restProps = _objectWithoutProperties(props, _excluded);
  var gateDividerStyle = useDividerStyle({
    labelPosition: labelPosition
  });
  var colorMap = {
    'divider-1': 'var(--gui-color-divider-1)',
    'divider-2': 'var(--gui-color-divider-2)',
    'divider-3': 'var(--gui-color-divider-3)',
    'divider-4': 'var(--gui-color-divider-4)',
    'divider-5': 'var(--gui-color-divider-5)'
  };
  return /*#__PURE__*/React__default.createElement(Divider$1, _objectSpread2(_objectSpread2({}, restProps), {}, {
    color: color || colorMap[type],
    labelPosition: "center",
    styles: objectDeepMerging(gateDividerStyle, styles)
  }));
};

export { Divider };
//# sourceMappingURL=Divider.js.map
